// 9fbef606107a605d69c0edbcd8029e5d
export default {
  DEFAULT_SELECT: 'Please Select',
  SPC_DEFAULT_SELECT: 'Select Gift Service Type',
};
